import React from 'react';
import PropTypes from 'prop-types';

import { Card } from 'react-bootstrap-5';

import { connect } from 'react-redux';
import { addAssigneeGroup as addApproverGroup, changeStepMode, removeStep } from './store/workflow/actions';

import AddControl from 'components/add_control/v2';
import ApproverGroup from './approver_group';
import ManagedInput from 'components/form/managed_input';
import RemoveControl from './remove_control';
import { modes } from './helper';

export const Step = ({ addApproverGroup, changeStepMode, removeStep, step }) => {
  return (
    <Card>
      <Card.Header className="d-flex justify-content-between align-items-center gap-2">
        <div className="d-flex align-items-center gap-2">
          <h6>Step {step.index + 1}</h6>
          {step.assigneeGroups.length > 1 &&
            <ManagedInput
              className="pt-1"
              name={`stepMode-${step.index}`}
              options={modes}
              type="radioGroup"
              value={step.mode}
              onValueChange={value => changeStepMode(step, value)}
            />
          }
        </div>

        <RemoveControl ariaLabel="remove-step" onClick={() => removeStep(step)} />
      </Card.Header>

      <Card.Body>
        {step.assigneeGroups.map(approverGroup => (
          <ApproverGroup
            approverGroup={approverGroup}
            key={approverGroup.key}
            step={step}
          />
        ))}

        <AddControl label="Add Approver Group" onClick={() => addApproverGroup(step)} />
      </Card.Body>
    </Card>
  );
};

Step.propTypes = {
  addApproverGroup: PropTypes.func.isRequired,
  changeStepMode: PropTypes.func.isRequired,
  removeStep: PropTypes.func.isRequired,
  step: PropTypes.shape({
    assigneeGroups: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string.isRequired
    })).isRequired,
    index: PropTypes.number.isRequired
  }).isRequired
};

const mapDispatchToProps = {
  addApproverGroup,
  changeStepMode,
  removeStep
};

export default connect(null, mapDispatchToProps)(Step);
